module.exports = __webpack_public_path__ + "static/media/person.85be30b9.png";